import React, { useContext, useEffect, useState } from "react";
import { controller, endpoints } from "../../../api/actions/api";
import * as actions from "../../../api/actions/actions";
import { connect } from "react-redux";
import { AppContext } from "../../../App";
import RepNav from "./RepNav";
import { Table } from "../../../layout";
import moment from "moment";
import { TableCell } from "@mui/material";

const tblHeader = () => (
  <div className="d-flex a-center flex-wrap">
    <h2 className="border-left h fw-4 fs-16 gray-color tx-upp">
      Expense Details
    </h2>
  </div>
);

const ExpDtls = (props) => {
  const { _getById, _hoa } = props;
  const { setLoader } = useContext(AppContext);
  const [csvHeader, setCsvHeader] = useState([]);
  const [tblData, setTblData] = useState([]);
  const [payments, setPayments] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [sortDate, setSortDate] = useState({
    fromDate: `1/1/${new Date().getFullYear()}`,
    toDate: `12/31/${new Date().getFullYear()}`,
  });

  useEffect(() => {
    setCsvHeader([
      { key: "paidDate", label: "Date" },
      { key: "descr", label: "Description" },
      { key: "account", label: "Account" },
      { key: "catName", label: "Category" },
      { key: "vendorName", label: "Vendor" },
      { key: "amt", label: "Amount" },
    ]);
    return () => {
      setCsvHeader([]);
    };
  }, []);

  useEffect(() => {
    setTblData([
      ...filteredData.map((j) => {
        return {
          ...j,
          account: j.bankAcc && j.bankAcc.accName,
          catName: j.category && j.category.name,
          vendorName: j.vendor && j.vendor.name,
          amt: `$ ${j.amount.toLocaleString()}`,
        };
      }),
    ]);
    return () => {
      setTblData([]);
    };
  }, [filteredData]);

  useEffect(() => {
    if (_hoa.id) {
      _getById(endpoints.AP + controller.GetByHoa, _hoa.id, null, (res) => {
        res.status === 200 &&
          setPayments([...res.result.filter((j) => j.isComplete)]);
        setLoader(false);
      });
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_hoa]);

  useEffect(() => {
    payments &&
      setFilteredData([
        ...payments.filter(
          (j) =>
            moment(j.paidDate, "MM/DD/YYYY") >=
              moment(sortDate.fromDate, "MM/DD/YYYY") &&
            moment(j.paidDate, "MM/DD/YYYY") <=
              moment(sortDate.toDate, "MM/DD/YYYY")
        ),
      ]);

    return () => {
      setFilteredData([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payments, sortDate]);

  return (
    <>
      <div className="mt-20 mb-10">
        <RepNav
          {...{
            csvHeader,
            csvData: tblData,
            sortDate,
            setSortDate,
            title: "Expense Details",
            showTitle: false,
          }}
        />
      </div>
      <div>
        <Table
          shadow={false}
          ActionComp={() => <></>}
          HeaderComp={tblHeader}
          tblHead={[
            { id: "paidDate", label: "Date" },
            { id: "descr", label: "Description" },
            { id: "account", label: "Account" },
            { id: "catName", label: "Category" },
            { id: "vendorName", label: "Vendor" },
            { id: "amt", label: "Amount" },
          ]}
          tblData={tblData}
          FooterRow={() => (
            <>
              <TableCell className="gray-color fw-6 fs-italic fs-16">
                Total Expenses
              </TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell className="gray-color fw-6 fs-italic fs-16">
                $&nbsp;
                {tblData
                  .map((j) => j.amount)
                  .reduce((x, y) => x + y, 0)
                  .toLocaleString()}
              </TableCell>
            </>
          )}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  _hoa: state.storeData.defHoa,
});

const mapActionToProps = {
  _getById: actions.getById,
  _delete: actions.Delete,
};

export default connect(mapStateToProps, mapActionToProps)(ExpDtls);
